import { Link } from "react-router-dom";
import LangSelect from "../LangSelect/LangSelect";
import { Span } from "../Text/Text";
import { useAuth } from "../../utils/hooks/useAuth";
import { RoutesE } from "../../routes/routesData";
import { clss } from "../../utils/helpers/styleHelpers";

import styles from "./footer.module.scss";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";

export type FooterVariant = "light" | "dark";

const Footer = ({ variant = "light" }: { variant?: FooterVariant }) => {
  const { currentUser } = useAuth();
  const isMobile = isMobileOrTablet();
  const isDark = variant === "dark";

  return (
    <footer
      className={clss([styles.footerWrapper, isDark ? styles.dark : ""])}
      data-no-print
    >
      <div className={styles.footerLeft}>
        {isDark ? (
          // Public marketing footer keeps the original dark bar: the LangSelect uses its
          // default (white-on-dark) styling.
          <LangSelect />
        ) : (
          // Light (authenticated) footer: the language selector is redundant on mobile — it is
          // already available in the navigation (hamburger) menu — so only show it on desktop.
          !isMobile && (
            <LangSelect
              selectStyles={{
                // Light footer: dark readable text + a visible (grey) control border,
                // overriding the white styles used in the dark sidebar context.
                singleValue: (provided) => ({ ...provided, color: "#333" }),
                control: (provided) => ({
                  ...provided,
                  width: "fit-content",
                  height: 34,
                  background: "transparent",
                  borderRadius: 8,
                  border: "1px solid #c4c8cb",
                  boxShadow: "none",
                }),
              }}
            />
          )
        )}
        {currentUser && !isMobile && (
          <>
            <Link to={RoutesE.TERMS} className={styles.termsLink}>
              <Span>Terms of use</Span>
            </Link>
            <Link to={RoutesE.PRIVACY_POLICY} className={styles.termsLink}>
              <Span>Privacy Policy</Span>
            </Link>
          </>
        )}
      </div>
      <div>
        <span>
          <Span>© Powered by</Span>{" "}
          <a href="https://www.jumbomail.me/en/" target="_blank">
            JUMBOmail.me
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
